import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setPrinting } from './actions';

const printingSelector = (state) => state.printing;

export const usePrinting = {
  state: () => {
    return useSelect(printingSelector);
  },
  actions: () => {
    return {
      setPrinting: useAction(setPrinting),
    };
  },
};
